import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IIndustry, IIndustryInitialState } from "./industryModel";
import {
  ActiveInactiveIndustry,
  createIndustry,
  deleteIndustry,
  getAllActiveIndustries,
  getAllIndustries,
  getIndustryByID,
  updateIndustry,
  IndustryDetailsImageUpload,
} from "./services/industry.services";

const initialState: IIndustryInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  IndustryID: null,
  IndustryList: [],
  IndustryDetail: {
    Title: "",
    URL: "",
    ShortDescription: "",
    LongDescription: "",
    MetaTitle: "",
    MetaKeyword: "",
    MetaDescription: "",
    IsActive: 1,
  },
};

const industrySlice = createSlice({
  name: "industry",
  initialState,
  reducers: {
    clearIndustryDetails: (state) => {
      state.IndustryDetail = initialState.IndustryDetail;
    },
    setIndustryID: (state, action) => {
      state.IndustryID = action.payload;
    },
    clearIndustryID: (state) => {
      state.IndustryID = initialState.IndustryID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllIndustries.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllIndustries.fulfilled,
      (state, action: PayloadAction<IIndustry[]>) => {
        state.loading = false;
        state.IndustryList = action.payload || [];
      },
    );
    builder.addCase(getAllIndustries.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.IndustryList = [];
    });
    builder.addCase(createIndustry.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createIndustry.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createIndustry.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateIndustry.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateIndustry.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateIndustry.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteIndustry.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteIndustry.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteIndustry.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getIndustryByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getIndustryByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.IndustryDetail = action.payload;
    });
    builder.addCase(getIndustryByID.rejected, (state, action) => {
      state.loading = false;
      state.IndustryDetail = initialState.IndustryDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveIndustries.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveIndustries.fulfilled,
      (state, action: PayloadAction<IIndustry[]>) => {
        state.loading = false;
        state.IndustryList = action.payload || [];
      },
    );
    builder.addCase(getAllActiveIndustries.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.IndustryList = [];
    });
    builder.addCase(ActiveInactiveIndustry.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveIndustry.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveIndustry.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(IndustryDetailsImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(IndustryDetailsImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(IndustryDetailsImageUpload.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearIndustryDetails, clearIndustryID, setIndustryID } =
  industrySlice.actions;
export default industrySlice.reducer;
